import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { HttpService } from './http-service.service';

@Injectable({
  providedIn: 'root'
})
export class LoanProductsService {
  private loanProductsSubject = new BehaviorSubject<any[]>([]);
  public loanProducts$ = this.loanProductsSubject.asObservable();
  public loanProducts = toSignal(this.loanProducts$, { initialValue: [] });
  private httpService = inject(HttpService);

  async fetchLoanProducts(): Promise<void> {
    if (this.loanProducts.length > 0) return;
    try {
      const res: any = await firstValueFrom(this.httpService.httpGet<any>('/product-offers', false));
      if (res && res.data) {
        this.loanProductsSubject.next(res.data);
      } else if (Array.isArray(res)) {
        this.loanProductsSubject.next(res);
      }
    } catch (_err) {
      this.loanProductsSubject.next([]);
    }
  }
}
